export default __webpack_public_path__ + "assets/appstore-badge.png";